import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const CONSENT_KEY = 'nf_cookie_consent';

let initialized = false;

function hasConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY) === 'accepted';
  } catch {
    return false;
  }
}

export function initPostHog() {
  if (initialized || !POSTHOG_KEY) return;

  posthog.init(POSTHOG_KEY, {
    api_host: '/ingest',
    ui_host: 'https://eu.posthog.com',
    capture_pageview: false,
    capture_pageleave: true,
    persistence: 'localStorage',
    autocapture: false,
    opt_out_capturing_by_default: !hasConsent(),
  });

  initialized = true;
}

export function enableTracking() {
  if (!POSTHOG_KEY) return;
  if (!initialized) initPostHog();
  posthog.opt_in_capturing();
}

export function disableTracking() {
  if (!POSTHOG_KEY || !initialized) return;
  posthog.opt_out_capturing();
}

export function trackPageView(path) {
  if (!POSTHOG_KEY || !initialized) return;
  if (posthog.has_opted_out_capturing()) return;
  posthog.capture('$pageview', { $current_url: window.location.href, $pathname: path });
}

export function trackEvent(eventName, properties = {}) {
  if (!POSTHOG_KEY || !initialized) return;
  if (posthog.has_opted_out_capturing()) return;
  posthog.capture(eventName, properties);
}

export default posthog;
